"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Label = (props) => {
    const { visible, ...otherProps } = props;
    const classes = {
        label: true,
        'no-display': visible === true
    };
    if (props.type === 'span') {
        return (react_1.default.createElement("span", { ...otherProps, className: (0, classnames_1.default)(classes, props.className), style: props.style }, props.children));
    }
    else {
        return (react_1.default.createElement("label", { ...otherProps, className: (0, classnames_1.default)(classes, props.className), style: props.style }, props.children));
    }
};
Label.defaultProps = {
    type: 'span'
};
exports.default = Label;
